import React from "react";

export type LabelProps = {
  labelKey: string;
  background: string;
  text: string;
  ring: string;
  label: string;
};

const LabelUI: React.FC<LabelProps> = ({
  labelKey,
  background,
  text,
  ring,
  label,
}) => {
  return (
    <div className="">
      <span
        key={labelKey}
        className={`inline-flex items-center rounded-md ${background} px-2 py-1 text-xs font-medium ${text} ring-1 ring-inset ${ring} mt-2`}
      >
        {label}
      </span>
    </div>
  );
};

export default LabelUI;
